// extracted by mini-css-extract-plugin
module.exports = {"root":"_1765a6","large":"_63bbdc","iconTextWithTooltip":"_42f043","infoCircleContainer":"_d870e7"};